import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/lock.svg'


const _withScopeId = n => (_pushScopeId("data-v-798d44da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "detail-container",
  ref: "scrollContainerRef"
}
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["datetime"]
const _hoisted_6 = { class: "bottom" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mark",
  "aria-hidden": "true"
}, "Q.", -1 /* HOISTED */))
const _hoisted_8 = {
  key: 0,
  class: "type"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = {
  key: 1,
  class: "lock-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_11 = { class: "row-wrapper" }
const _hoisted_12 = {
  key: 0,
  class: "title"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "image-wrapper"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "첨부파일", -1 /* HOISTED */))
const _hoisted_17 = { "aria-labelledby": 'attachment-title' }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mark",
  "aria-hidden": "true"
}, "A.", -1 /* HOISTED */))
const _hoisted_20 = { class: "title" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  class: "btns-wrapper",
  role: "group",
  "aria-label": "문의 관리 버튼"
}
const _hoisted_23 = {
  key: 0,
  class: "right-wrapper"
}
const _hoisted_24 = ["disabled", "aria-label"]
const _hoisted_25 = ["disabled", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 작성자 질문글 제목 "),
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        (!!$props.vocDetail.statusName)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["status", [$setup.vocStatusCodeMap[$props.vocDetail.statusCode]]]),
              "aria-label": `문의 상태: ${$props.vocDetail.statusName}`
            }, _toDisplayString($props.vocDetail.statusName), 11 /* TEXT, CLASS, PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true),
        _createElementVNode("time", {
          class: "date",
          datetime: $props.vocDetail.createdTs
        }, _toDisplayString($props.vocDetail.createdTs), 9 /* TEXT, PROPS */, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        ($props.vocDetail.vocTypeName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, " [" + _toDisplayString($props.vocDetail.vocTypeName) + "] ", 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("h1", _hoisted_9, _toDisplayString($props.vocDetail.title), 1 /* TEXT */),
        ($props.vocDetail.secretYn)
          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createCommentVNode(" 작성자 질문글 본문 "),
    _createElementVNode("section", _hoisted_11, [
      ($props.vocDetail.lineName ?? $props.vocDetail.lineRouteName)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
            _createTextVNode(" 노선이용시간 : "),
            _createElementVNode("span", null, _toDisplayString($props.vocDetail.lineName ?? $props.vocDetail.lineRouteName), 1 /* TEXT */),
            ($props.vocDetail.boardDtm)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " (" + _toDisplayString($props.vocDetail.boardDtm) + ") ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("p", {
        class: "content",
        innerHTML: $setup.DOMPurify.sanitize($props.vocDetail.bodyText)
      }, null, 8 /* PROPS */, _hoisted_14),
      ($props.vocDetail.files?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.vocDetail.files, (file, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: file?.fileUid,
                  src: $setup.imageUrls[index],
                  alt: `${$props.vocDetail.title}_문의 이미지 (총 ${$props.vocDetail.files.length}개 중)`
                }, null, 8 /* PROPS */, _hoisted_18))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" 작성자 질문글에 대한 답변 "),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.vocDetail.vocReplies, (reply, index) => {
      return (_openBlock(), _createElementBlock("article", {
        class: "answer-wrapper",
        key: index
      }, [
        _createElementVNode("header", null, [
          _hoisted_19,
          _createElementVNode("h2", _hoisted_20, _toDisplayString(reply.title), 1 /* TEXT */)
        ]),
        _createElementVNode("div", {
          class: "content",
          innerHTML: $setup.DOMPurify.sanitize(reply.bodyText),
          role: "region",
          "aria-label": "답변 내용",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.validateUrlLink && $setup.validateUrlLink(...args)))
        }, null, 8 /* PROPS */, _hoisted_21)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", _hoisted_22, [
      ($setup.isMyPost)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("button", {
              class: "btn default-btn",
              type: "button",
              disabled: $props.vocDetail.statusCode !== $setup.VocStatusCode.SUBMIT,
              "aria-label": 
            $props.vocDetail.statusCode !== $setup.VocStatusCode.SUBMIT
              ? '수정 (접수 상태에서만 가능)'
              : '수정'
          ,
              onClick: $setup.emitOnClickEditBtn
            }, " 수정 ", 8 /* PROPS */, _hoisted_24),
            _createElementVNode("button", {
              class: "btn default-btn",
              type: "button",
              disabled: $props.vocDetail.statusCode !== $setup.VocStatusCode.SUBMIT,
              "aria-label": 
            $props.vocDetail.statusCode !== $setup.VocStatusCode.SUBMIT
              ? '삭제 (접수 상태에서만 가능)'
              : '삭제'
          ,
              onClick: $setup.emitOnClickDeleteBtn
            }, " 삭제 ", 8 /* PROPS */, _hoisted_25)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.scrollContainerRef)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 0,
          container: $setup.scrollContainerRef,
          class: "scroll-top-btn"
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["FooterButton"], {
      title: "목록",
      "aria-label": "문의 목록으로 돌아가기",
      onOnClickFooterButton: $setup.goToQnaList
    })
  ], 512 /* NEED_PATCH */))
}